import { Stack, Typography } from '@mui/material';
import { t } from 'i18next';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

interface Props {
  mode: 'generate' | 'upload';
  setMode: (mode: 'generate' | 'upload') => void;
}

const GenerateLeadListTab: React.FC<Props> = ({ mode, setMode }) => {
  const { classes, cx } = useStyles();

  return (
    <Stack className={classes.tabs} direction={'row'}>
      <Stack className={cx(classes.tab, mode === 'generate' ? 'active' : undefined)} gap={0.5} onClick={() => setMode('generate')}>
        <Typography className={classes.tabPrimaryText}>{t('generateLeadList')}</Typography>
        <div className={classes.activeIndicator} />
      </Stack>
      <Stack className={cx(classes.tab, mode === 'upload' ? 'active' : undefined)} gap={0.5} onClick={() => setMode('upload')}>
        <Typography className={classes.tabPrimaryText}>{t('uploadLeadList')}</Typography>
        <div className={classes.activeIndicator} />
      </Stack>
    </Stack>
  );
};

const useStyles = makeStyles<void, 'tabPrimaryText' | 'activeIndicator'>()((theme, _params, classes) => ({
  tabs: {
    width: '100%',
    borderBottom: `1px solid ${theme.palette.greys.light}`,
    marginBottom: '8px',
  },
  tab: {
    position: 'relative',
    cursor: 'pointer',
    padding: '8px 16px',
    '&:hover': {
      [`& .${classes.tabPrimaryText}`]: {
        color: theme.palette.primary.main,
      },
    },
    '&.active': {
      [`& .${classes.tabPrimaryText}`]: {
        color: theme.palette.primary.main,
      },
      [`& .${classes.activeIndicator}`]: {
        visibility: 'visible',
      },
    },
  },
  activeIndicator: {
    visibility: 'hidden',
    position: 'absolute',
    bottom: '0px',
    left: '16px',
    width: 'calc(100% - 32px)',
    height: '4px',
    background: theme.palette.primary.main,
    borderRadius: '4px',
  },
  tabPrimaryText: {
    fontSize: theme.typography.pxToRem(16),
    marginTop: '4px',
  },
}));

export default GenerateLeadListTab;
